var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-jpg';
                    var viewUrl = 'gfx/sprite.svg#view-icon-jpg';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };